module.exports = __webpack_public_path__ + "static/joe-rogan-03f14f26f8adccfd584b4a9f40748ee8.jpg";